<div class="fluid_container web-view spotlight-background" fxFill fxHide.xs fxHide.sm   fxHide.lt-md fxFlex.md >
    
    <div class="header">    
        <div class="premierecentered">
            <span *ngIf="!archive">Spotlights Full Lineup </span>
            <span *ngIf="archive">Archived Spotlights </span>            
            <div  class="web_cart">
                <app-shopping-cart ></app-shopping-cart>
            </div>
     </div>


    </div>


  
    <div class="content">

        <div class="fxlineup" fxLayout="row wrap" fxLayoutGap="22px grid"  fxFlex.md="100" style="width: 79.5vw;">

            <div  fxFlex="33.3333%" 
             *ngFor="let premiere of premierelist"
              fxFlex.md="46" fxFlex.lt-lg="40%"  fxFlex.gt-xs="33%"  fxFlex.gt-lg="33%" >

            <app-lineup-card [premiere]="premiere" ></app-lineup-card>

            </div>

        </div>

    </div>

</div>



<!-- ********************WEB-VIEW ENDED******************** -->







<!-- ********************MOBILE-VIEW******************** -->


<div class="mobile-view spotlight-background"                                        
                                fxHide.lg 
                                fxHide.md 
                                fxHide.lt 
                                fxFlex.lt-md
                                fxShow.xs  
                                fxHide.gt-lg 
                                >
    <div  class="mobile_cart">
        <app-shopping-cart ></app-shopping-cart>
    </div> 
    
    <div class="header_mobile">
        <div class="premierecentered_mobile">
            <span *ngIf="!archive">Spotlights Full Lineup </span>
            <span *ngIf="archive">Archived Spotlights </span>            
        </div>
    </div>

    <div class="content_mobile"  >
        
        <div fxFlex="100%"  class="fxlineup" fxLayout="column grid" fxFlex.lt-md fxLayoutGap="15px">

            <div *ngFor="let premiere of premierelist">
            
                <app-premiere-card-mobile-view [premiere]="premiere"></app-premiere-card-mobile-view>
            
            </div>

        </div>
    
    </div>
        
</div>


<!-- ********************MOBILE-VIEW ENDED******************** -->
